import { Routes, Route } from 'react-router-dom'
import Home from '../pages/private/home'
import RecoverPasswordFirst from '../pages/public/recoverPassword/recoverPasswordFirst/RecoverPasswordFirst.component'
import RecoverPasswordThird from '../pages/public/recoverPassword/recoverPasswordThird/RecoverPasswordThird.component'
import RecoverPasswordFourth from '../pages/public/recoverPassword/recoverPasswordFourth/RecoverPasswordFourth.component'
import Login from '../pages/public/login'
import Register from '../pages/public/register/Register.component'
import ChangePassword from '../pages/private/changePassword/ChangePassword'
import ChangedPassword from '../pages/private/changePassword/ChangedPassword'
import Profile from '../pages/private/profile'
import Indicators from '../pages/private/indicators'
import SearchVehicles from '../pages/public/searchVehicles'
import UnitDetail from '../pages/public/unitDetail'
import DocumentDetail from '../pages/public/documentDetail'
import UploadDocument from '../pages/public/uploadDocument'
import AxiosInstance from '../api/config/Http'
import { cleanSOData } from '../utils/accountUtils'
import { useToastContext } from '../context/ToastContext'
import { ToastType } from '../components/toast/ToastType'
import  VehicleFleet from '../pages/private/vehicleFleet/vehicleFleet'
import CreateMaintenance from '../pages/public/createMaintenance'
import  ConsultMaintenance from '../pages/private/consultMaintenance/consultMaintenance'
import  ConsultTickets from '../pages/private/tickets/consultTickets'
import AuthorizeMaintenance from '../pages/private/autorizeMaintenance'
import ViewMaintenance from '../pages/private/viewMaintenance/viewMaintenance'
import Faqs from '../pages/public/faqs/Faqs'
import Contact from '../pages/private/contact/Contact'
import Checklist from '../pages/public/checklist'
import ChecklistList from '../pages/public/checklist/checklistList'
import Unit from "../pages/private/unit/unit";
import  Notifications from '../pages/private/notifications/notifications'
import  DocumentsVto from '../pages/private/documentsVto/documentsVto'
import WorkOrdersDesktop from '../pages/private/workOrder/workOrderDesktop'
import InvoicesDesktop from '../pages/private/invoice/invoiceDesktop'

const AppRouter = () => {
  const [, , showToast] = useToastContext()

  AxiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const win: Window = window
      if (error.response && error.response.status === 401 && win.location.pathname !== '/login') {
        cleanSOData()
        win.location = "/web/login";
      } else {
        return error
      }
    }
  )

  return (
    <Routes >
      <Route path="/web/login" element={<Login />} />
      <Route path="/web/recover-password" element={<RecoverPasswordFirst />} />
      <Route path="/web/recover-password/create/:passwordKey" element={<RecoverPasswordThird title="Nueva contraseña" submitButtonRedirect="/web/recover-password/created" labelNewPasswordText="Ingrese una nueva contraseña" />} />
      <Route path="/web/recover-password/created" element={<RecoverPasswordFourth />} />
      <Route path="/web/register" element={<Register />} />
      <Route path="/web/faqs" element={<Faqs/>} />
      <Route path="/web/activate-user/set-security/:passwordKey" element={<RecoverPasswordThird title="Crear contraseña" submitButtonRedirect="/web/activate-user/set-security/setted" labelNewPasswordText="Ingrese una contraseña" />} />
      <Route path="/web/activate-user/set-security/setted" element={<RecoverPasswordFourth />} />
      <Route path="/web/change-password" element={<ChangePassword />} />
      <Route path="/web/change-password/changed" element={<ChangedPassword />} />
      <Route path="/web/profile" element={<Profile />} />
      <Route path="/web/" element={<Indicators />} />
      <Route path="/web/catalog" element={<Home />} />
      <Route path="/web/vehicleFleet" element={<VehicleFleet />} />
      <Route path="/web/documentsVto" element={<DocumentsVto />} />
      <Route path="/web/notifications" element={<Notifications />} />
      <Route path="/web/search-vehicles" element={<SearchVehicles />} />
      <Route path="/web/unit-detail/:domain" element={<UnitDetail />} />
      <Route path="/web/unit-detail/:domain/documents/:id" element={<DocumentDetail />} />
      <Route path="/web/unit-detail/:domain/documents/:id/upload" element={<UploadDocument />} />
      <Route path="/web/create-maintenance" element={<CreateMaintenance />} />
      <Route path="/web/consult-maintenance/:domain/:id" element={<ConsultMaintenance />} />
      <Route path="/web/tickets" element={<ConsultTickets />} />
      <Route path="/web/authorize-maintenance/:id" element={<AuthorizeMaintenance/>} />
      <Route path="/web/maintenance-view/:id" element={<ViewMaintenance/>} />
      <Route path="/web/contact" element={<Contact/>} />
      <Route path="/web/checklist" element={<Checklist />} />
      <Route path="/web/checklist-list/:id/:domain" element={<ChecklistList />} />
      <Route path="/web/unit/:domain" element={<Unit />} />
      <Route path="/web/*" element={<Indicators />} />
      <Route path="/web/workOrderDesktop" element={<WorkOrdersDesktop />} />
      <Route path="/web/invoiceDesktop" element={<InvoicesDesktop />} />
    </Routes>
  )
}

export default AppRouter
